import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  close() {
    this.element.close()
  }

  backdropClick(event) {
    // Close modal if clicking the backdrop (the dialog element itself, not its content)
    if (event.target === this.element) {
      this.close()
    }
  }

  onClose() {
    // Optional: Add any cleanup logic here when modal closes
  }
}
